<template>
  <div class="employee-list-container">
    <!-- 花名册页面 -->
    <div v-if="!showProfile">
      <div class="header-section">
        <div>
          <h2 class="page-title">员工花名册</h2>
          <div class="employee-count">在册人数：{{ staffTotalCount }}</div>
        </div>
        <div class="action-buttons">
          <input
            type="text"
            v-model="searchKeyword"
            placeholder="请输入姓名进行搜索"
            class="search-input"
          />
          <button @click="handleSearch" class="search-btn blue-btn">
            <img src="@/assets/search-icon.png" alt="搜索" class="btn-icon" />
            搜索
          </button>
          <button class="download-btn blue-btn" @click="downloadExcel">
            <img
              src="@/assets/download-icon.png"
              alt="下载模板"
              class="btn-icon"
            />
            下载模板
          </button>
          <button class="export-btn blue-btn" @click="toggleExportMenu">
            <img src="@/assets/export-icon.png" alt="导出" class="btn-icon" />
            导出
            <div v-if="showExportMenu" class="export-menu">
              <div class="menu-item" @click="exportToExcel">导出Excel</div>
              <div class="menu-item" @click="exportToCSV">导出CSV</div>
            </div>
          </button>
          <button class="import-btn blue-btn" @click="showImportDialog = true">
            <img src="@/assets/import-icon.png" alt="导入" class="btn-icon" />
            导入
          </button>
          <!-- 新增按钮 -->
          <button class="add-btn blue-btn" @click="showAddDialog = true">
            <span class="plus-icon">+</span>
            新增
          </button>
          <button
            class="import-btn blue-btn"
            @click="showOrganizationImport = true"
          >
            <img src="@/assets/import-icon.png" alt="导入" class="btn-icon" />
            导入组织架构
          </button>
        </div>
      </div>
      <!-- 新增员工对话框 -->
      <div v-if="showAddDialog" class="add-dialog-overlay">
        <div class="add-dialog">
          <div class="dialog-header">
            <h3>新增员工</h3>
          </div>
          <div class="dialog-body">
            <div class="form-group">
              <label class="form-label">姓名</label>
              <input
                type="text"
                v-model="newEmployee.name"
                placeholder="请输入姓名"
                class="form-input"
              />
            </div>
            <div class="form-group">
              <label class="form-label">电话号码</label>
              <input
                type="text"
                v-model="newEmployee.phone"
                placeholder="请输入电话号码"
                class="form-input"
              />
            </div>
            <div class="form-group">
              <label class="form-label">部门</label>
              <input
                type="text"
                v-model="newEmployee.department"
                placeholder="请输入部门"
                class="form-input"
              />
            </div>
            <div class="form-group">
              <label class="form-label">入职时间</label>
              <input
                type="date"
                v-model="newEmployee.joinDate"
                class="form-input"
              />
            </div>
            <div class="form-group">
              <label class="form-label">工号</label>
              <input
                type="text"
                v-model="newEmployee.number"
                placeholder="请输入工号"
                class="form-input"
              />
            </div>
            <div class="form-group">
              <label class="form-label">毕业院校</label>
              <input
                type="text"
                v-model="newEmployee.graduation_school"
                placeholder="请输入毕业院校"
                class="form-input"
              />
            </div>
            <div class="form-group">
              <label class="form-label">最高学历</label>
              <input
                type="text"
                v-model="newEmployee.highest_education"
                placeholder="请输入最高学历"
                class="form-input"
              />
            </div>
            <div class="form-group">
              <label class="form-label">性别</label>
              <input
                type="text"
                v-model="newEmployee.gender"
                placeholder="请输入性别信息"
                class="form-input"
              />
            </div>
            <div class="form-group">
              <label class="form-label">出生日期</label>
              <input
                type="date"
                v-model="newEmployee.birth_day"
                class="form-input"
              />
            </div>
          </div>
          <div class="dialog-footer">
            <button @click="cancelAdd" class="blue-btn">取消</button>
            <button @click="confirmAdd" class="blue-btn">新增</button>
          </div>
        </div>
      </div>

      <!-- 编辑员工对话框 -->
      <div v-if="showEditDialog" class="add-dialog-overlay">
        <div class="add-dialog">
          <div class="dialog-header">
            <h3>修改员工信息</h3>
          </div>
          <div class="dialog-body">
            <div class="form-group">
              <label class="form-label">姓名</label>
              <input
                type="text"
                v-model="editingEmployee.name"
                placeholder="请输入姓名"
                class="form-input"
              />
            </div>
            <div class="form-group">
              <label class="form-label">电话号码</label>
              <input
                type="text"
                v-model="editingEmployee.phone"
                placeholder="请输入电话号码"
                class="form-input"
              />
            </div>
            <div class="form-group">
              <label class="form-label">部门</label>
              <input
                type="text"
                v-model="editingEmployee.department"
                placeholder="请输入部门"
                class="form-input"
              />
            </div>
            <div class="form-group">
              <label class="form-label">入职时间</label>
              <input
                type="date"
                v-model="editingEmployee.joinDate"
                class="form-input"
              />
            </div>
            <div class="form-group">
              <label class="form-label">工号</label>
              <input
                type="text"
                v-model="editingEmployee.number"
                placeholder="请输入工号"
                class="form-input"
                readonly
              />
              <div class="red-tip">
                员工工号不可以被修改，其他信息可以更改！
              </div>
            </div>
            <div class="form-group">
              <label class="form-label">状态</label>
              <input
                type="text"
                v-model="editingEmployee.currently_employed"
                placeholder="请输入状态"
                class="form-input"
              />
            </div>
          </div>
          <div class="dialog-footer">
            <button @click="cancelEdit" class="blue-btn">取消</button>
            <button @click="confirmEdit" class="blue-btn">保存</button>
          </div>
        </div>
      </div>

      <!-- 导入对话框 -->
      <div v-if="showImportDialog" class="import-dialog">
        <div class="dialog-content">
          <h3>导入员工数据</h3>
          <div class="import-options">
            <label class="import-option">
              <input type="radio" v-model="importType" value="excel" />
              Excel文件
            </label>
            <!--            <label class="import-option">-->
            <!--              <input type="radio" v-model="importType" value="csv"> CSV文件-->
            <!--            </label>-->
          </div>
          <div class="file-selector">
            <input
              type="file"
              ref="fileInput"
              @change="handleFileChange"
              accept=".xlsx,.csv"
              style="display: none"
            />
            <button @click="$refs.fileInput.click()" class="file-select-btn">
              选择文件
            </button>
            <span v-if="selectedFile" class="selected-file-name">{{
              selectedFile.name
            }}</span>
          </div>
          <div class="dialog-buttons">
            <button @click="importData" class="confirm-btn blue-btn">
              确认导入
            </button>
            <button @click="showImportDialog = false" class="cancel-btn">
              取消
            </button>
          </div>
        </div>
      </div>

      <!-- 员工表格 -->
      <div class="table-container">
        <div
          class="employee-table-wrapper"
          style="height: calc(100vh - 300px); overflow-y: auto"
        >
          <div class="table-header">
            <span class="header-item">序号</span>
            <span class="header-item name-column">姓名</span>
            <span class="header-item">手机号</span>
            <span class="header-item">部门</span>
            <span class="header-item">工号</span>
            <span class="header-item">入职时间</span>
            <span class="header-item">状态</span>
            <span class="header-item">操作</span>
          </div>

          <div
            class="table-row"
            v-for="(emp, index) in filteredEmployees"
            :key="emp.id"
            @click="showEmployeeProfile(emp)"
          >
            <span class="row-item">{{ index + 1 }}</span>
            <span class="row-item employee-name">{{ emp.name }}</span>
            <span class="row-item">{{ emp.phone }}</span>
            <span class="row-item">{{ emp.department }}</span>
            <span class="row-item">{{ emp.number }}</span>
            <span class="row-item">{{ emp.joinDate }}</span>
            <span class="row-item">{{
              emp.currently_employed || "未填写"
            }}</span>
            <span class="row-item actions">
              <img
                src="@/assets/edit-icon.png"
                alt="编辑"
                class="action-icon"
                @click.stop="editEmployee(emp.id)"
              />
              <img
                src="@/assets/delete-icon.png"
                alt="删除"
                class="action-icon"
                @click.stop="deleteEmployee(emp)"
                title="删除员工"
              />
            </span>
          </div>
        </div>

        <!-- 分页组件 -->
        <div class="pagination-container">
          <el-pagination
            :current-page="pageParams.pageNum"
            :page-size="pageParams.pageSize"
            :page-sizes="[10, 20, 50, 100]"
            layout="total, sizes, prev, pager, next, jumper"
            :total="pageParams.total"
            @size-change="handlePageSizeChange"
            @current-change="handlePageChange"
          />
        </div>
      </div>
    </div>

    <!-- 档案页面 -->
    <div v-else class="profile-page">
      <EmployeeProfile
        :employee="selectedEmployee"
        @close="hideEmployeeProfile"
      />
    </div>
    <!-- 组织架构导入模态框 -->
    <OrganizationImport
      v-if="showOrganizationImport"
      @close="closeOrganizationImport"
    />
  </div>
</template>
<script>
import EmployeeProfile from "./EmployeeProfile.vue";
import OrganizationImport from "./OrganizationImport.vue";
// axios已在main.js中全局配置，使用this.$http代替直接导入的axios
export default {
  name: "EmployeeList",
  components: {
    EmployeeProfile,
    OrganizationImport,
  },
  data() {
    return {
      showAddDialog: false,
      searchKeyword: "",
      showProfile: false,
      selectedEmployee: null,
      showExportMenu: false,
      showImportDialog: false,
      showOrganizationImport: false,
      importType: "excel",
      selectedFile: null,
      employees: [], // 初始化为空数组，从接口获取数据
      staffTotalCount: 0, // 员工总数，从接口获取
      pageParams: {
        pageNum: 1, // 当前页
        pageSize: 10, // 每页条数
        total: 0, // 总条数
      },
      // 关键修复：正确定义newEmployee对象
      newEmployee: {
        name: "",
        phone: "",
        department: "",
        joinDate: "",
        number: "",
        birth_day: "",
        graduation_school: "",
        highest_education: "",
        gender: "",
        currently_employed: "",
      },
      // 编辑员工相关
      showEditDialog: false,
      editingEmployee: null,
    };
  },
  created() {
    this.loadEmployees(); // 组件创建时立即加载数据
    this.loadStaffTotalCount(); // 加载员工总数
  },
  computed: {
    filteredEmployees() {
      return this.employees.filter((emp) =>
        emp.name.toLowerCase().includes(this.searchKeyword.toLowerCase())
      );
    },
  },
  methods: {
    // showOrganizationImport() {
    //   this.showOrganizationImport = true
    // },

    closeOrganizationImport() {
      this.showOrganizationImport = false;
    },
    // 打开编辑对话框
    editEmployee(employeeId) {
      // 找到要编辑的员工
      const employee = this.employees.find((emp) => emp.id === employeeId);
      if (employee) {
        // 深拷贝员工对象，避免直接修改原数据
        this.editingEmployee = JSON.parse(JSON.stringify(employee));
        this.showEditDialog = true;
      }
    },
    // 取消编辑
    cancelEdit() {
      this.showEditDialog = false;
      this.editingEmployee = null;
    },
    // 保存编辑
    async confirmEdit() {
      try {
        const response = await this.$http.post(
          "/staff/update/byNumber",
          this.editingEmployee
        );
        if (response.data.success) {
          // 更新本地员工列表
          const index = this.employees.findIndex(
            (emp) => emp.id === this.editingEmployee.id
          );
          if (index !== -1) {
            this.employees[index] = JSON.parse(
              JSON.stringify(this.editingEmployee)
            );
          }
          this.showEditDialog = false;
          this.editingEmployee = null;
          this.$message.success(response.data.message);
        } else {
          this.$message.error(response.data.message);
        }
      } catch (error) {
        console.error("编辑员工失败:", error);
        this.$message.error("修改过程中出现错误");
      }
    },
    async toggleExportMenu() {
      try {
        console.log("点击导出按钮");
        const response = await this.$http({
          method: "get",
          url: "/staff/export/all",
          responseType: "blob",
        });

        // 处理文件下载
        this.handleFileDownload(response, "全部员工数据");

        // 关闭菜单
        this.showExportMenu = false;
      } catch (error) {
        this.handleDownloadError(error, "导出全部员工数据失败");
      }
    },
    //   try {
    //     console.log('点击导出按钮');
    //
    //     // 构建查询参数
    //     const params = {};
    //     if (this.searchKeyword && this.searchKeyword.trim() !== '') {
    //       params.name = this.searchKeyword.trim();
    //     }
    //
    //     const response = await axios({
    //       method: 'get',
    //       url: 'http://localhost:8082/api/staff/export/condition',
    //       params: params,
    //       responseType: 'blob'
    //     });
    //
    //     // 处理文件下载
    //     this.handleFileDownload(response, '搜索结果员工数据');
    //
    //     // 关闭菜单
    //     this.showExportMenu = false;
    //   } catch (error) {
    //     this.handleDownloadError(error, '导出搜索结果失败');
    //   }
    // },
    // 处理文件下载
    handleFileDownload(response, filename) {
      try {
        // 创建Blob对象
        const blob = new Blob([response.data], {
          type:
            response.headers["content-type"] ||
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });

        // 创建下载链接
        const downloadUrl = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = downloadUrl;

        // 从响应头获取文件名
        const contentDisposition = response.headers["content-disposition"];
        let actualFilename = filename;

        if (contentDisposition) {
          const filenameMatch = contentDisposition.match(/filename="?(.+)"?/);
          if (filenameMatch && filenameMatch[1]) {
            actualFilename = filenameMatch[1];
          }
        }

        link.download = actualFilename;
        link.style.display = "none";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(downloadUrl);
      } catch (error) {
        this.handleDownloadError(error, "文件下载处理失败");
      }
    },

    // 修正后的 parseBlobError 方法
    async parseBlobError(blobData, customMessage, originalError) {
      return new Promise((resolve) => {
        const reader = new FileReader();

        reader.onload = () => {
          try {
            const errorData = JSON.parse(reader.result);
            this.errorMessage =
              customMessage +
              ": " +
              (errorData.error || errorData.message || "服务器错误");
            this.showErrorModal = true;
            resolve();
          } catch (parseError) {
            // 如果JSON解析失败，使用原始错误信息
            this.errorMessage =
              customMessage + ": " + (originalError?.message || "未知错误");
            this.showErrorModal = true;
            resolve();
          }
        };

        reader.onerror = () => {
          this.errorMessage = customMessage + ": 读取错误响应失败";
          this.showErrorModal = true;
          resolve();
        };

        reader.readAsText(blobData);
      });
    },

    // 修正后的 handleDownloadError 调用方式
    handleDownloadError(error, customMessage) {
      console.error("导出错误:", error);

      this.errorTitle = "导出失败";

      if (error.response && error.response.data instanceof Blob) {
        // 如果是Blob类型的错误响应
        this.parseBlobError(error.response.data, customMessage, error).then(
          () => {
            // 错误信息已设置，可以在这里添加额外的处理
          }
        );
      } else {
        this.errorMessage =
          customMessage + ": " + (error.message || "未知错误");
        this.showErrorModal = true;
      }
    },
    // 从服务端获取员工数据（分页查询）
    async loadEmployees() {
      try {
        const response = await this.$http.get("/staff/StaffPage", {
          params: this.pageParams, // 传递分页参数（pageNum、pageSize）
        });

        // 检查响应体中的code字段
        if (response && response.data) {
          if (response.data.code === "200") {
            const resultData = response.data.data; // 注意这里需要两层data
            this.pageParams.total = resultData.total || 0;
            // 数据处理和验证
            this.employees = (resultData.records || [])
              .map((employee) => this.processEmployeeData(employee))
              .filter((employee) => employee !== null);
          } else {
            console.warn("获取员工数据失败，响应code:", response.data.code);
          }
        } else {
          console.warn("获取员工数据失败，响应数据不完整");
        }
      } catch (error) {
        // 401错误由main.js中的全局响应拦截器统一处理，不再在组件中重复处理
        // 仅保留其他状态码的处理逻辑
        if (error.response?.status === 404) {
          // 尝试使用旧接口作为备用方案
          try {
            const oldResponse = await this.$http.get("/staff");
            if (oldResponse.data) {
              // 模拟分页处理
              const allData = oldResponse.data
                .map((employee) => this.processEmployeeData(employee))
                .filter((employee) => employee !== null);

              this.pageParams.total = allData.length;
              // 手动计算当前页数据
              const startIndex =
                (this.pageParams.pageNum - 1) * this.pageParams.pageSize;
              const endIndex = startIndex + this.pageParams.pageSize;
              this.employees = allData.slice(startIndex, endIndex);
            }
          } catch (oldError) {
            console.error("备用接口也失败");
          }
        } else {
          console.error("获取员工数据时发生错误");
        }
      }
    },

    // 页面改变时触发
    handlePageChange(pageNum) {
      this.pageParams.pageNum = pageNum;
      this.loadEmployees(); // 重新加载数据
    },

    // 页面大小改变时触发
    handlePageSizeChange(pageSize) {
      this.pageParams.pageSize = pageSize;
      this.pageParams.pageNum = 1; // 重置为第一页
      this.loadEmployees(); // 重新加载数据
    },
    /**
     * 处理员工数据
     */
    processEmployeeData(employeeData) {
      if (!this.validateEmployeeData(employeeData)) {
        return null;
      }
      // 详细日志输出，追踪number字段处理过程
      console.log("处理前的员工数据:", {
        id: employeeData.id,
        number: employeeData.number,
        name: employeeData.name,
        phone: employeeData.phone,
        department: employeeData.department,
        joinDate: this.formatJoinDate(employeeData.joinDate),
        birth_day: this.formatJoinDate(employeeData.birth_day),
        graduation_school: employeeData.graduation_school,
        highest_education: employeeData.highest_education,
        gender: employeeData.gender,
        currently_employed: employeeData.currently_employed,
      });
      return {
        id: employeeData.id,
        name: employeeData.name || "未知",
        phone: employeeData.phone || "未填写",
        department: employeeData.department || "未分配",
        number: employeeData.number,
        joinDate: this.formatJoinDate(employeeData.joinDate),
        birth_day: this.formatJoinDate(employeeData.birth_day), // 修正：使用正确的字段名
        graduation_school: employeeData.graduation_school, // 修正：使用正确的字段名
        highest_education: employeeData.highest_education,
        gender: employeeData.gender,
        currently_employed: employeeData.currently_employed,
      };
    },
    // 从服务端获取员工总数
    async loadStaffTotalCount() {
      try {
        console.log("开始请求员工总数接口...");
        const response = await this.$http.get("/staff/StaffTotalCount");

        console.log("员工总数接口响应:", response);

        // 检查响应体
        if (response && response.data) {
          // 记录响应数据的完整结构
          console.log("响应数据结构:", {
            hasCode: response.data.code !== undefined,
            codeValue: response.data.code,
            hasData: response.data.data !== undefined,
            dataType: typeof response.data.data,
            responseDataType: typeof response.data,
          });

          // 更宽松的成功判断逻辑
          if (
            response.data.code === "200" ||
            response.data.code === 200 ||
            response.status === 200
          ) {
            if (typeof response.data.data === "number") {
              this.staffTotalCount = response.data.data;
            } else {
              this.staffTotalCount = this.employees.length;
            }
          } else {
            if (typeof response.data.data === "number") {
              this.staffTotalCount = response.data.data;
            } else if (
              response.data.data &&
              typeof response.data.data.total === "number"
            ) {
              this.staffTotalCount = response.data.data.total;
            }
          }
        } else {
          // 使用当前员工列表长度作为备用
          this.staffTotalCount = this.employees.length;
        }
      } catch (error) {
        // 401错误由main.js中的全局响应拦截器统一处理
        console.error("获取员工总数时发生错误:", error);
        // 详细记录错误信息
        if (error.response) {
          console.error("错误响应:", {
            status: error.response.status,
            data: error.response.data,
            headers: error.response.headers,
            config: error.response.config,
          });
        } else if (error.request) {
          console.error("请求已发出但未收到响应:", error.request);
        } else {
          console.error("请求配置错误:", error.message);
        }
        // 发生错误时使用当前员工列表长度作为备用
        this.staffTotalCount = this.employees.length;
      }
    },
    /**
     * 验证员工数据完整性
     */
    validateEmployeeData(data) {
      const requiredFields = ["id", "name"];
      const missingFields = requiredFields.filter((field) => !data[field]);

      if (missingFields.length > 0) {
        console.warn(`员工数据缺失字段: ${missingFields.join(", ")}`);
        return false;
      }

      return true;
    },

    /**
     * 格式化入职日期
     */
    formatJoinDate(dateString) {
      if (!dateString) return "未填写";

      // 处理包含T的日期格式
      if (dateString.includes("T")) {
        return dateString.split("T")[0];
      }

      return dateString;
    },
    showEmployeeProfile(employee) {
      this.selectedEmployee = employee;
      this.showProfile = true;
    },
    hideEmployeeProfile() {
      this.showProfile = false;
    },
    async handleSearch() {
      // console.log('搜索:', this.searchKeyword)
      if (!this.searchKeyword.trim()) {
        console.error("请输入搜索关键词:");
        return;
      }
      try {
        // 构建带参数的URL
        const keyword = this.searchKeyword ? this.searchKeyword.trim() : "";
        // let apiUrl = 'http://localhost:8082/api/staff';
        //
        // // 如果有搜索关键词，添加到URL参数中
        // if (keyword) {
        //   apiUrl = `http://localhost:8082/api/staff/search?keyword=${encodeURIComponent(keyword)}`;
        // }

        const response = await this.$http.get(
          `/staff/search?keyword=${encodeURIComponent(keyword)}`
        );

        // 数据处理和验证
        const responseData = response.data;

        // 动态数据提取策略
        let employeeData = [];
        if (Array.isArray(responseData)) {
          employeeData = responseData;
        } else if (responseData?.data && Array.isArray(responseData.data)) {
          employeeData = responseData.data;
        }

        this.employees = employeeData
          .map((employee) => this.processEmployeeData(employee))
          .filter((employee) => employee !== null);

        this.$message.success("员工数据搜索成功");
      } catch (error) {
        console.error("获取员工数据搜索失败:", error);
        // this.handleDataError(error)
      }
    },

    deleteEmployee(employee) {
      this.$confirm(`确定要删除员工 ${employee.name} 吗？`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          try {
            await this.$http.delete(`/staff/delete/${employee.id}`);
            this.employees = this.employees.filter(
              (emp) => emp.id !== employee.id
            );
            this.$message.success("删除成功");
          } catch (error) {
            this.$message.error("删除失败");
          }
        })
        .catch(() => {});
    },

    // 新增员工相关方法
    showAddDialogFunc() {
      this.showAddDialog = true;
    },
    cancelAdd() {
      this.showAddDialog = false;
      this.resetNewEmployee();
    },
    confirmAdd() {
      if (this.validateNewEmployee()) {
        if (this.validateNewEmployee()) {
          this.insertStaffToServer();
        }
      }
    },
    insertStaffToServer() {
      this.isSubmitting = true;
      this.clearErrors();

      this.$http
        .post("/staff/insert", this.newEmployee)
        .then((response) => {
          this.isSubmitting = false;
          const result = response.data;

          if (result.success) {
            alert(result.message);
            const newEmp = {
              id: Date.now(),
              ...this.newEmployee,
            };
            this.employees.push(newEmp);
            this.showAddDialog = false;
            this.resetNewEmployee();
          } else {
            alert(result.message);
          }
        })
        .catch((error) => {
          this.isSubmitting = false;
          console.error("添加员工失败:", error);
          alert("添加员工失败，请检查网络连接");
        });
    },
    clearErrors() {
      this.errors = {
        name: "",
        phone: "",
        department: "",
        joinDate: "",
        number: "",
        birth_day: "",
        graduation_school: "",
        highest_education: "",
        gender: "",
      };
    },
    resetNewEmployee() {
      this.newEmployee = {
        name: "",
        phone: "",
        department: "",
        joinDate: "",
        number: "",
        birth_day: "",
        graduation_school: "",
        highest_education: "",
        gender: "",
      };
    },
    validateNewEmployee() {
      if (!this.newEmployee.name.trim()) {
        alert("请输入姓名");
        return false;
      }
      if (!this.newEmployee.phone.trim()) {
        alert("请输入电话号码");
        return false;
      }
      if (!this.newEmployee.department.trim()) {
        alert("请输入部门");
        return false;
      }
      if (!this.newEmployee.number.trim()) {
        alert("请输入工号");
        return false;
      }
      return true;
    },
    formatDate(date) {
      if (!date) return "";
      return new Date(date).toLocaleDateString("zh-CN");
    },
    // 修复后的Excel下载函数
    downloadExcel() {
      this.$http({
        method: "get",
        url: "/File/getExcelFile", // 使用相对路径
        params: { type: "Huamingce" },
        responseType: "blob",
      })
        .then((response) => {
          // 确保正确获取MIME类型
          const contentType =
            response.headers["content-type"] ||
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";

          const blob = new Blob([response.data], {
            type: contentType,
          });

          // 改进文件名解析逻辑
          let filename = "huamingce.xlsx";
          const disposition = response.headers["content-disposition"];

          if (disposition) {
            // 优先处理RFC 5987编码的文件名
            const filenameMatch = disposition.match(
              /filename\*=(?:UTF-8'')?([^;]+)/i
            );
            if (filenameMatch && filenameMatch[1]) {
              filename = decodeURIComponent(filenameMatch[1]);
            } else {
              // 处理普通filename参数
              const normalMatch = disposition.match(/filename=([^;]+)/i);
              if (normalMatch && normalMatch[1]) {
                filename = normalMatch[1].replace(/['"]/g, "");
              }
            }
          }

          // 创建下载链接并触发下载
          const link = document.createElement("a");
          link.href = URL.createObjectURL(blob);
          link.download = filename;
          link.style.display = "none";

          document.body.appendChild(link);
          link.click();

          // 改进清理逻辑
          setTimeout(() => {
            document.body.removeChild(link);
            URL.revokeObjectURL(link.href);
          }, 100);
        })
        .catch((error) => {
          console.error("下载失败:", error);
          // 改进错误信息显示
          let errorMsg = "下载失败";
          if (error.response) {
            // 处理Blob类型的错误响应
            if (error.response.data instanceof Blob) {
              const reader = new FileReader();
              reader.onload = () => {
                try {
                  const errorData = JSON.parse(reader.result);
                  errorMsg = errorData.message || errorMsg;
                } catch {
                  errorMsg = "服务器返回错误";
                }
              };
              reader.readAsText(error.response.data);
            } else {
              errorMsg = error.response.data?.message || errorMsg;
            }
          } else {
            errorMsg = error.message || errorMsg;
          }
          this.$message.error(errorMsg);
        });

      this.showExportMenu = false;
    },
    exportToCSV() {
      console.log("导出CSV");
      this.showExportMenu = false;
    },
    handleFileChange(event) {
      this.selectedFile = event.target.files[0];
    },
    async importData() {
      if (!this.selectedFile) return;
      console.log("导入文件:", this.selectedFile.name);
      this.showImportDialog = false;

      this.uploading = true;
      this.uploadStatus = null;
      this.uploadResult = null;

      const formData = new FormData();
      formData.append("file", this.selectedFile);

      try {
        const response = await this.$http.post("/excelImport", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
          onUploadProgress: (progressEvent) => {
            if (progressEvent.total) {
              this.uploadProgress = Math.round(
                (progressEvent.loaded * 100) / progressEvent.total
              );
            }
          },
        });

        // 上传成功
        this.uploadStatus = "success";
        this.uploadResult = {
          success: response.data,
          message: response.data
            ? "数据导入成功！"
            : "数据导入失败，请检查文件格式",
        };

        if (response.data) {
          this.$message.success("数据导入成功！");
          //this.resetComponent()
          // 可以触发父组件的刷新事件
          this.$emit("import-success");
        } else {
          this.$message.error("数据导入失败");
        }
        console.log("返回值");
        console.log(response.data);
      } catch (error) {
        console.log("所以返回值");
        console.log(error.response ? error.response.data : error.message);
        console.error("上传失败:", error);
        this.uploadStatus = "exception";
        this.uploadResult = {
          success: false,
          message:
            "上传失败：" + (error.response?.data?.message || error.message),
        };
        this.$message.error("上传失败，请检查网络连接或服务器状态");
      } finally {
        this.uploading = false;
      }
    },
  },
};
</script>

<style scoped>
.employee-list-container {
  padding: 20px;
  height: 100%;
  background-color: #f5f7fa;
  font-family: "PingFang SC", "Microsoft YaHei", sans-serif;
  max-width: 1200px;
  margin: 0 auto;
}

.header-section {
  display: flex;
  justify-content: space-between;
  margin-bottom: 25px;
  padding-left: 0px; /* 进一步减小与左侧菜单的距离 */
}

.header-section > div:first-child {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.action-buttons {
  display: flex;
  align-items: center;
}

.page-title {
  margin-bottom: 10px;
  margin-left: 5px; /* 进一步减小与左侧菜单的距离 */
  color: #303133;
  font-size: 20px;
  font-weight: 500;
}

.employee-count {
  margin-left: 5px;
  margin-bottom: 0;
  color: #606266;
  font-size: 14px;
}

.action-buttons {
  display: flex;
  gap: 15px;
  align-items: center;
  margin-right: 10px; /* 调整：减少向右的间距 */
}

.search-input {
  padding: 10px 15px;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  width: 250px;
  font-size: 14px;
}

.blue-btn {
  background-color: #409eff;
  color: white;
  border: none;
  padding: 10px 15px;
  border-radius: 4px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  transition: background-color 0.3s;
}

.blue-btn:hover {
  background-color: #66b1ff;
}

.btn-icon {
  width: 16px;
  height: 16px;
}

.table-container {
  background: #fff;
  padding: 20px;
  border-radius: 4px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  margin-left: 5px; /* 进一步减小与左侧菜单的距离 */
  position: relative;
  min-height: 400px; /* 确保有足够的最小高度 */
}

.employee-table {
  border: 1px solid #ebeef5;
  border-radius: 4px;
  width: 100%;
}

.pagination-container {
  position: sticky;
  bottom: 0;
  margin-top: 15px;
  text-align: right;
  border-top: 1px solid #e0e0e0;
  padding: 15px 0 5px 0;
  display: flex;
  justify-content: flex-end;
  background: #fff;
  z-index: 10;
}

.table-header {
  display: grid;
  grid-template-columns: 80px 120px 150px 150px 120px 150px 120px 100px;
  padding: 15px;
  background-color: #f5f7fa;
  font-weight: 500;
  text-align: left;
}

.header-item {
  padding: 0 10px;
}

.table-row {
  display: grid;
  grid-template-columns: 80px 120px 150px 150px 120px 150px 120px 100px;
  padding: 15px;
  border-bottom: 1px solid #ebeef5;
  cursor: pointer;
  transition: background-color 0.2s;
  text-align: left;
}

.table-row:hover {
  background-color: #f5f7fa;
}

.row-item {
  padding: 0 10px;
  margin: 5px 0;
}

.employee-name {
  font-weight: 500;
  color: #409eff;
}

.actions {
  display: flex;
  gap: 15px;
  align-items: center;
}

.action-icon {
  width: 18px;
  height: 18px;
  cursor: pointer;
  transition: opacity 0.2s;
}

.action-icon:hover {
  opacity: 0.7;
}

.import-dialog {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.dialog-content {
  background: white;
  padding: 25px;
  border-radius: 6px;
  width: 450px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.import-options {
  margin: 20px 0;
  display: flex;
  gap: 20px;
}

.file-selector {
  margin: 20px 0;
  display: flex;
  align-items: center;
  gap: 15px;
}

.dialog-buttons {
  display: flex;
  justify-content: flex-end;
  gap: 15px;
  margin-top: 25px;
}

.cancel-btn {
  padding: 10px 15px;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  background: white;
  cursor: pointer;
}

.export-menu {
  position: absolute;
  right: 0;
  top: 100%;
  background: white;
  border: 1px solid #ebeef5;
  border-radius: 4px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  z-index: 10;
  margin-top: 5px;
}

.menu-item {
  padding: 10px 20px;
  cursor: pointer;
  white-space: nowrap;
}

.menu-item:hover {
  background-color: #f5f7fa;
}

.name-column {
  min-width: 100px;
}
.add-dialog-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}
.add-dialog {
  position: relative;
  z-index: 10000;
  background: white;
  border-radius: 12px;
  width: 480px;
  max-width: 90vw;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
  overflow: hidden;
  animation: dialogAppear 0.3s ease-out;
}
.employee-list-container {
  position: relative;
}
.form-group {
  margin-bottom: 20px;
}
.dialog-footer {
  padding: 20px 24px;
  border-top: 1px solid #f0f0f0;
  display: flex;
  justify-content: flex-end;
  gap: 12px;
}
.dialog-header {
  padding: 15px;
  border-bottom: 1px solid #f0f0f0;
  background: linear-gradient(135deg, #1890ff 0%, #096dd9 100%);
  color: white;
}
.dialog-body {
  padding: 24px;
  max-height: 70vh;
  overflow-y: auto;
}
.form-label {
  display: block;
  margin-bottom: 8px;
  color: #333;
  font-size: 14px;
  font-weight: 500;
}

.form-input {
  width: 100%;
  padding: 10px 12px;
  border: 1px solid #d9d9d9;
  border-radius: 6px;
  font-size: 14px;
  transition: all 0.3s ease;
  box-sizing: border-box;
}
.form-input {
  width: 100%;
  padding: 10px 12px;
  border: 1px solid #d9d9d9;
  border-radius: 6px;
  font-size: 14px;
  transition: all 0.3s ease;
  box-sizing: border-box;
}

.form-input:focus {
  outline: none;
  border-color: #1890ff;
  box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2);
}

.red-tip {
  color: #f56c6c;
  font-size: 12px;
  margin-top: 5px;
  line-height: 1.5;
}
</style>
